import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import * as SerializationApi from '@/app/state-serialization/api';
import FlipcardComponent from "./flipcard-component.vue";
import { FlipcardStateProtobufSerializer } from "./flipcard-state-protobuf-serializer";
import { IncludeFlipcardHandler } from './include-flipcard-handler';

export const flipcardFactoryModule = new ContainerModule(bind => {
  bind<Api.InteractiveComponentPlugin>(Api.InteractiveComponentPluginSymbol)
    .toConstantValue(FlipcardComponent)
    .whenTargetNamed("flipcard");

  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeFlipcardHandler);
  bind(SerializationApi.StateSerializationPluginSymbol).to(FlipcardStateProtobufSerializer)
});
